import { Map, MapMarker } from 'react-kakao-maps-sdk';

const KakaoMap = ({ location }) => {
    const { pointX, pointY } = location;

    const handleMarkerClick = () => {
        const kakaoMapUrl = `https://map.kakao.com/link/map/${pointY},${pointX}`;
        window.open(kakaoMapUrl, '_blank');
    };

    return (
        <Map
            id="map"
            center={{
                lat: pointY,
                lng: pointX,
            }}
            style={{
                width: '100%',
                height: '100%',
            }}
            level={3}
        >
            <MapMarker
                position={{ lat: pointY, lng: pointX }}
                onClick={handleMarkerClick}
                clickable={true} // Cho phép click
            />
        </Map>
    );
};

export default KakaoMap;